import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

import CuminButton from '@components/Button';
import Controls from '@components/Controls';
import InputError from '@components/InputError';
import { Form } from '@components/UseForm';
import ExitIntentLogoThree from '@public/assets/svg/ExitIntentLogoThree.svg';

import { useStyles } from '../useStyles';

interface IEmailSection {
  emailAdd: string;
  emailErr: string;
  handleInputEmailChange: (e: any) => void;
  onClickErrorCloseIcon: () => void;
  onClickGetDiscount: () => void;
  handleClose: () => void;
}

const EmailSection = ({
  emailAdd,
  emailErr,
  handleInputEmailChange,
  onClickErrorCloseIcon,
  onClickGetDiscount,
  handleClose,
}: IEmailSection) => {
  const classes = useStyles();

  //to get discount on hit of Enter from keyboard
  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === 'Enter') {
        onClickGetDiscount();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [onClickGetDiscount]);

  return (
    <Box className={classes.rightContainer}>
      <Box className={classes.wrapper}>
        <Box className={classes.dTDisplayNone}>
          <ExitIntentLogoThree />
        </Box>
        <Typography
          variant="h2"
          align="center"
          color="cinnamon.main"
          className={classes.title}
        >
          Get 15% off your first order!
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="garamMasala.main"
          m="20px 0 20px"
        >
          Join our club to get exclusive offers, early access to new dishes, and
          more!
        </Typography>
        <Form onSubmit={onClickGetDiscount} className={classes.form}>
          <Box sx={{ position: 'relative' }}>
            <Controls.InputField
              name="email"
              placeholder="Enter your email address"
              value={emailAdd}
              onChange={handleInputEmailChange}
              autoComplete="email"
              type="email"
            />
            <InputError
              error={emailErr}
              className={classes.emailError}
              onClickErrorCloseIcon={onClickErrorCloseIcon}
            />
          </Box>
          <CuminButton
            color="cinnamon"
            variant="contained"
            textColor="whitePepper.main"
            width="240px"
            height="48"
            borderRadius="24"
            className={classes.discountBtn}
            onClick={onClickGetDiscount}
          >
            Get My Discount
          </CuminButton>
        </Form>
        <Typography
          variant="body2"
          color="cinnamon.main"
          className={classes.noThanksText}
          onClick={handleClose}
        >
          No thanks, I hate sweet deals
        </Typography>
        <Typography variant="caption" align="center" color="cumin.main">
          You’ll also get notified on amazing new dishes, promotional offers,
          events, and more! We pinky promise not to spam you.
        </Typography>
      </Box>
    </Box>
  );
};

export default EmailSection;
